<template>
  <div>
    <div class="pageTitleWrap">
      <vs-breadcrumb :items="breadcrumb" class="marLeft12"></vs-breadcrumb>
    </div>

    <div class="main-wrap">
      <vs-card>
        <!-- 活动配置 -->
        <div class="form">
          <div class="title first">活动规则配置</div>
          <div class="vs-row">
            <span class="label" style="line-height: 40px"
              ><span class="redText">*</span>推送类型</span
            >
            <div>
              <selectPara
                :disabled="changTypeFlag"
                :options="option1"
                v-model="params.pushType"
                @selectVal="selectVal"
              ></selectPara>
            </div>
          </div>

          <div class="vs-row" v-if="params.pushType != 2">
            <span class="label"><span class="redText">*</span>覆盖门店</span>
            <div>
              <div style="margin-bottom: 10px">
                <el-radio v-model="selectStoreType" :label="1"
                  >全部门店</el-radio
                >
                <el-radio v-model="selectStoreType" :label="2"
                  >部分门店</el-radio
                >
              </div>
              <span v-if="selectStoreType === 1" class="disabled-select">
                全部门店
                <vs-icon
                  class="icon"
                  icon-pack="material-icons"
                  icon="keyboard_arrow_down"
                >
                </vs-icon>
              </span>
              <v-select
                v-else
                :options="storeOptions"
                v-model="storeInfo"
                multiple
                push-tags
                :closeOnSelect="false"
                @search="handleSearchStore"
                class="form-item mutiple-select"
                :filterable="false"
              >
              </v-select>
              <vs-button
                v-if="selectStoreType === 2"
                @click="handleImportStore"
                type="flat"
                class="import-store"
                >批量输入
              </vs-button>
            </div>
          </div>

          <div v-if="params.pushType == 2">
            <div class="vs-row" style="padding-left: 10px">
              <span>配置方式</span>
              <span
                v-if="params.pushType == 2"
                style="margin-left: 30px; color: #ccc"
                >创建模板后导入</span
              >
              <!-- <span v-if="params.pushType==1" style="margin-left:30px;color:#ccc;">手动创建</span> -->
            </div>
            <div class="vs-row">
              <span class="label" style="line-height: 40px"
                ><span class="redText">*</span>覆盖门店</span
              >
              <div>
                <select-para :options="option2" :disabled="true"></select-para>
              </div>
            </div>
          </div>

          <div class="vs-row">
            <span class="label" style="padding-top: 8px"
              ><span class="redText">*</span>活动类型</span
            >
            <!-- <v-select
              :options="typeOptions"
              v-model="params.type"
              class="form-item"
              :reduce="(item) => item.code"
              :disabled=flag
            /> -->
            <selectPara
              :options="typeOptions"
              v-model="params.type"
              :disabled="flag"
            ></selectPara>
          </div>

          <div class="title">基本信息配置</div>
          <vs-row vs-type="flex">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
              <span class="label"><span class="redText">*</span>活动名称</span>
              <vs-input v-model="params.activityName" />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="imageUpload">
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-align="center"
              vs-w="10"
            >
              <span class="label offset"
                ><span class="redText">*</span>活动头图</span
              >
              <div>
                <ImageUpload
                  v-on:updateUrl="updateUrlBanner"
                  :limitNum="1"
                  :limitSize="limitSize"
                  :imgResolutionH="750"
                  :imgResolutionW="520"
                  :imageUrl="params.bannerIconA"
                />
                <div class="imageTips">
                  建议尺⼨750*520像素， 文件大小不超过2M，仅支持jpeg、png格式;
                  最多添加1张
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-align="center"
              vs-w="12"
            >
              <span class="label offset" style="padding-left: 15px"
                >活动配图</span
              >
              <div>
                <ImageUpload
                  v-on:updateUrl="updateUrlIlu"
                  :limitNum="10"
                  :limitSize="limitSize"
                  :imgResolutionW="670"
                  :imageUrl="params.ilustri"
                  :deletable="true"
                />
                <div class="imageTips">
                  建议宽度670像素，高度不限，文件大小不超过 2M，仅支持jpeg、png
                  格式; 最多添加10张
                </div>
              </div>
            </vs-col>
          </vs-row>
          <div class="vs-row">
            <span class="label" style="margin-top: 50px"
              ><span class="redText">*</span>活动说明</span
            >
            <vs-textarea v-model="params.desc" height="130px" width="390px" />
          </div>

          <template v-if="!(params.type === 1)">
            <div class="title">收集信息配置</div>
            <div
              class="config-item"
              v-for="(oItem, oItemIndex) in questions"
              :key="oItemIndex"
            >
              <div class="type">
                {{ questionTypes[oItem.questionType - 1].name }}
              </div>
              <div class="content">
                <div class="label">标题</div>
                <vs-input
                  placeholder="请输入标题"
                  v-model="oItem.questionTitle"
                />
                <template
                  v-if="oItem.questionType === 1 || oItem.questionType === 2"
                >
                  <div class="label" style="margin-top: 12px">选项</div>
                  <div
                    class="option"
                    v-for="(option, optionIndex) in oItem.selectContent"
                    :key="optionIndex"
                  >
                    <vs-input
                      placeholder="请输入选项"
                      v-model="oItem.selectContent[optionIndex]"
                    />
                    <span class="btn" @click="addOptions(oItem, oItemIndex)"
                      >+</span
                    >
                    <span
                      class="btn"
                      @click="delOptions(oItem, oItemIndex)"
                      v-if="oItem.selectContent.length > 1"
                      >-</span
                    >
                  </div>
                </template>
                <div v-else-if="oItem.questionType === 4">
                  <div class="label" style="margin-top: 12px">图片数量</div>
                  <vs-input-number
                    @mousewheel.prevent
                    min="1"
                    max="10"
                    v-model="oItem.selectContent[0]"
                  />
                </div>
              </div>
              <div
                class="del"
                :style="oItem.questionType === 4 ? 'padding-bottom:0;' : ''"
              >
                <vs-icon
                  icon-pack="material-icons"
                  icon="delete"
                  @click="delQuestion(oItem, oItemIndex)"
                ></vs-icon>
                <span @click="delQuestion(oItem, oItemIndex)">删除</span>
              </div>
              <div style="padding: 0px 20px; flex: 1">
                <span v-if="oItem.questionType != 4">内容</span>
                <p v-if="oItem.questionType === 5">
                  展示信息创建完成后使用模板导入 （模板内非必填）
                </p>
                <p v-if="oItem.questionType === 1">
                  展示信息创建完成后使用模板导入 （模板内非必填）
                </p>
                <p v-if="oItem.questionType === 2">
                  展示信息创建完成后使用模板导入 （模板内非必填）
                </p>
                <p v-if="oItem.questionType === 3">
                  展示信息创建完成后使用模板导入 （模板内非必填）
                </p>
              </div>
            </div>
            <div>
              <div
                class="question-type"
                :style="questions.length ? 'margin-top: 20px' : ''"
              >
                <span style="margin-right: 10px">添加配置</span>
                <vs-button
                  v-for="(item, index) in questionTypes"
                  :key="index"
                  class="btn"
                  color="primary"
                  type="border"
                  size="small"
                  @click="addQuestion(item.name, item.value)"
                >
                  + {{ item.name }}
                </vs-button>
              </div>
            </div>
          </template>

          <template v-if="!(params.type === 1 || params.type === 2)">
            <!-- <div class="title">活动商品配置</div>
            <vs-row vs-type="flex">

            </vs-row> -->

            <div class="title">活动商品配置</div>
            <div class="flex">
              <!-- <vs-button type="border" size="small" @click.prevent="addGoods" class="common-btn">批量添加</vs-button> -->
              <!-- <vs-button type="border" size="small" @click.prevent="deleteBatchGoods" class="common-btn mar-left-8">批量删除</vs-button> -->
            </div>
            <vs-table :data="goodsInfo" class="wid100" noDataText="暂无数据">
              <template slot="thead">
                <vs-th v-for="(headData, index) in headData" :key="index">
                  {{ headData }}
                </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    {{ indextr + 1 }}
                  </vs-td>
                  <vs-td :data="tr.goodsCode">
                    {{ tr.goodsCode }}
                  </vs-td>
                  <vs-td :data="tr.barCode">
                    {{ tr.barCode }}
                  </vs-td>
                  <vs-td :data="tr.goodsName">
                    {{ tr.goodsName }}
                  </vs-td>
                  <!-- disabled -->
                  <vs-td :data="tr.price" v-if="params.pushType != 2">
                    <vs-input-number
                      @mousewheel.prevent
                      min="0"
                      v-model="tr.price"
                      @input="changePrice"
                    />
                  </vs-td>

                  <vs-td :data="tr.goodsCount" v-if="params.pushType != 2">
                    <vs-input-number
                      @mousewheel.prevent
                      min="0"
                      v-model="tr.goodsCount"
                    />
                  </vs-td>
                  <vs-td>
                    <vs-button
                      color="primary"
                      type="flat"
                      size="small"
                      @click="delItem(goodsInfo, tr.uuid)"
                    >
                      删除
                    </vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div style="color: red" v-if="showTip">
              *价格请输入正数，最多2位小数
            </div>

            <div class="add-goods">
              <vs-button
                color="primary"
                type="border"
                size="small"
                @click="addGoods"
                >添加商品
              </vs-button>
              <span class="tips">
                注：活动商品订单无需设置收集收货地址，下单流程会自动收集
              </span>
            </div>

            <!-- <div class="flex alignCenter marTop18 search-add-wrap" style="margin-top: 20px">
              <div class="input-tip">快捷录入</div>
              <search-input
                :autoFocus="true"
                :data="goodsOptions"
                :searchLimit="5"
                placeholder="请输入要添加的商品名或编号"
                inputClassses="w-full"
                show-action
                show-pinned
                hideGroupTitle
                background-overlay
                showName="skuName"
                @input="searchInputSuggest"
                @selected="selectOneGood" />
            </div> -->
          </template>
        </div>
        <div class="btns">
          <vs-button @click="cancelAffirm" type="border">取消</vs-button>
          <vs-button
            @click="save"
            :disabled="disabled"
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            >保存</vs-button
          >
        </div>
      </vs-card>
    </div>
    <!-- 批量输入门店弹窗 -->
    <vs-popup
      classContent="popup-imoprt-store"
      title="批量输入门店编号"
      :active.sync="popupSelectStore"
    >
      <vs-textarea v-model="importStoreIds" height="130px" width="390px" />
      <div class="tips">批量输入门店编号，支持换行</div>
      <div v-if="importStoreIds">* 系统已识别到{{ importStoreNum }}个门店</div>
      <vs-button @click="cancelImport" type="border">取消</vs-button>
      <vs-button @click="confirmImport">确认</vs-button>
    </vs-popup>

    <!-- 新增商品弹窗 -->
    <vs-prompt
      @cancel="goodsSuggest = ''"
      @accept="addBillGoods"
      title="选择需要添加的商品"
      acceptText="确认"
      cancelText="取消"
      :active.sync="showAddGoodDialog"
    >
      <div class="con-exemple-prompt">
        <div class="flex flexStart">
          <!-- <v-select v-model="categoryId" :options="categoryOptions" :reduce="opt => opt.id"
                        placeholder="请选择分类">
                <div slot="no-options">暂无选项</div>
            </v-select> -->
          <gc-cmp-vs-input
            v-model="goodsSuggest"
            maxlength="200"
            class="marLeft20"
            placeholder="请输入商品编码/名称"
          />
          <vs-button
            type="border"
            @click.prevent="queryGoods(goodsSuggest)"
            style="margin-left: 10px; padding: 0 22px"
          >
            查询</vs-button
          >
        </div>

        <gc-cmp-vs-table
          multiple
          v-model="selectedGoods"
          @selected="handleGoodsSelected"
          :data="goodsList"
          class="marTop18"
        >
          <template slot="thead">
            <vs-th>商品图片</vs-th>
            <vs-th>商品编码</vs-th>
            <vs-th>69码</vs-th>
            <vs-th>商品名称</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].picUrls">
                  <img
                    :src="data[indextr].picUrls"
                    style="width: 60px; height: 60px"
                  />
                </vs-td>
                <vs-td :data="data[indextr].goodsCode">
                  {{ data[indextr].goodsCode }}
                </vs-td>
                <vs-td :data="data[indextr].barCode">
                  {{ data[indextr].barCode }}
                </vs-td>
                <vs-td :data="data[indextr].goodsName">
                  {{ data[indextr].goodsName }}
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </gc-cmp-vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
  import selectPara from "@/components/selectPara";
  import { CommodityCategoryApi } from "@/modules/server-api/commodity-sys/category-manage";
  import { DistributionApi } from "@/modules/server-api/commodity-sys/distribution";
  import { Mod_Stores } from "@/modules/server-api/Stores";
  import constants from "../../../constants.ts";
  import ImageUpload from "@/modules/commodity-sys/components/ImageUpload";
  import { v4 as uuidv4 } from "uuid";
  import { debounce } from "@/plugins/utils";
  import SearchInput from "@/modules/wms-manage/components/searchInput.vue";
  import GcCmpVsTable from "@/group-cloud/components/vsTable";
  import GcCmpVsInput from "@/group-cloud/components/vsInput";

  export default {
    components: {
      ImageUpload,
      SearchInput,
      GcCmpVsTable,
      GcCmpVsInput,
      selectPara,
    },
    data() {
      return {
        changTypeFlag:false, //类型无法修改
        value1: '',
        flag: false,  //独立推送时 活动类型只限报名
        option1: [
          { label: "统一推送", value: 1 },
          { label: "独立推送", value: 2 },
        ],
        option2: [{ label: '模板内门店', value: '' }],
        disabled: false,
        showTip: false,
        limitSize: 2048, // 上传图片大小限制
        storeInfo: [], //门店信息
        params: {
          // 表单提交数据
          storeInfo: [],
          status: "",
          type: "",
          date: "",
          activityName: "",
          desc: "",
          bannerIconA: [],
          ilustri: [],
          pushType: "",
        },
        questionTypes: [
          // 收集信息配置类型

          { name: "单选", value: 1 },
          { name: "多选", value: 2 },
          { name: "输入框", value: 3 },
          { name: "图片", value: 4 },
          { name: "文本展示", value: 5 },

        ],
        questions: [], // 收集信息配置
        goodsInfo: [], // 活动商品配置列表数据
        goodsOptions: [], // 模糊搜索
        goodsList: [], // 商品list
        showAddGoodDialog: false,
        goodsSuggest: "",
        categoryOptions: [], //分类选项
        selectedGoods: [], //已选择的商品
        headData: [
          "序号",
          "商品编码",
          "69码",
          "商品名称",
          "价格(元)",
          "数量",
          "操作",
        ], //商品列表头部
        typeOptions: constants.typeOptions, // 活动类型

        storeOptions: [], //门店选项
        selectStoreType: '', // 是否是全部门店： 1全部门店 2部分门店
        isShowDate: false, // 初始不显示日期选择，有数据或新增时显示
        breadcrumb: [],
        isGetStore: false, // 是否获取到门店
        popupSelectStore: false, // 批量输入门店弹窗
        importStoreIds: "", //批量输入门店id,
        inputStoreInfo: [],
        importStoreNum: 0,
        isEditAllStore: false,
      };
    },
    computed: {
      detailId() {
        const id = this.$route.params.id;
        console.log("id", id);
        return id === "0" ? "" : id;
      },
    },
    created() {
      this.breadcrumb = [
        {
          title: "门店活动",
          url: "/distribution/storeactivities",
        },
        // {
        //   title: '活动配置',
        //   url: '/distribution/storeactivities'
        // },
        {
          title: this.detailId ? "活动配置-修改" : "活动配置-新增",
          active: true,
        },
      ];
      if (this.detailId) {
        this.getDetail().then(() => {
          // 编辑有数据时显示
          this.isShowDate = true;
        });
      }
      // this.queryGoods();
      // 新增显示
      this.isShowDate = true;
      this.handleSearchStore();
    },

    methods: {
      selectVal(val) {
        console.log(val, "========");
        if (val == 2) {
          this.params.type = 3
          this.flag = true
            this. headData=[
          "序号",
          "商品编码",
          "69码",
          "商品名称",
          "操作",
        ]
        } else {
          this.flag = false
           this. headData=[
          "序号",
          "商品编码",
          "69码",
          "商品名称",
           "价格(元)",
          "数量",
          "操作",
        ]
        }
      },
      openLoadingContained() { },

      handleInput(val) {
        console.log("handleInput", val);
      },
      changePrice(val) {
        console.log(val);
        const flag = this.validatePosNumber(val);
        this.showTip = !flag;
      },
      //校验是否是正数，最多两位小数
      validatePosNumber(val) {
        let rule = /^\d+(\.\d{0,2})?$/;
        let flag = true;
        if (!rule.test(val)) {
          flag = false;
          this.$forceUpdate();
        }
        return flag;
      },
      // 导入门店
      handleImportStore() {
        this.popupSelectStore = true;
      },
      // 取消导入
      cancelImport() {
        this.importStoreIds = "";
        this.popupSelectStore = false;
      },
      // 确认导入门店
      async confirmImport() {
        this.storeInfo.push(...this.inputStoreInfo);
        // 做去重
        var result = [];
        var obj = {};
        for (let i = 0; i < this.storeInfo.length; i++) {
          if (!obj[this.storeInfo[i].id]) {
            result.push(this.storeInfo[i]);
            obj[this.storeInfo[i].id] = true;
          }
        }
        console.log(result);
        this.storeInfo = result;
        this.cancelImport();
      },

      //模糊搜索获取sku信息
      async searchInputSuggest(value) {
        if (this.value != "") {
          const { result = [] } = await DistributionApi.queryGoods({
            name: value,
          });
          this.goodsOptions = result.map((item) => {
            const { code, name, id, picUrls } = item;
            // 格式化菜单
            return {
              goodsCode: code,
              goodsName: name,
              id,
              code,
              picUrls: picUrls[0],
            };
          });

          this.$forceUpdate();
        }
      },
      //选择单件商品
      selectOneGood(item) {
        console.log("===selectOneGood===");
        console.log(item);
        this.oneGoodSelected = item;
        //选择并添加
        this.addSuggestGood();
      },
      //模糊搜索新增商品
      addSuggestGood() {
        if (Object.keys(this.oneGoodSelected).length == 0) {
          this.$notifyError("请选择要新增的商品");
        } else {
          //设置入库数量及备注默认值
          this.oneGoodSelected.skuId = this.oneGoodSelected.id;
          //this.oneGoodSelected.skuName = this.oneGoodSelected.goodsName;
          this.goodsList.push(this.oneGoodSelected);
          this.tempGoodsList.push(this.oneGoodSelected);
        }
      },

      // 添加活动商品配置列表项
      addGoods() {
        this.goodsSuggest = "";
        this.showAddGoodDialog = true;
        this.selectedGoods = [];
        // this.getCategoryList(); //获取分类
        this.queryGoods(); //获取商品列表
      },

      //添加弹窗商品的时候
      async handleGoodsSelected(tr) {
        console.log(tr);
      },

      // 确定添加
      addBillGoods() {
        //已选择的数据
        this.selectedGoods.map((item) => {
          if (!this.goodsInfo.length) {
            return this.goodsInfo.push({
              price: 0,
              goodsCount: 1,
              ...item,
            });
          }
          const isRepeat = this.goodsInfo.findIndex((v) => v.code === item.code);
          if (isRepeat !== -1) {
            this.$set(
              this.goodsInfo[isRepeat],
              "goodsCount",
              ++this.goodsInfo[isRepeat].goodsCount
            );
          } else {
            this.goodsInfo.push({
              price: 0,
              goodsCount: 1,
              ...item,
            });
          }
        });
      },

      // //获取分类
      // async getCategoryList(){
      //     let resp = await CommodityCategoryApi.getCategoryList({});
      //     let resList = resp.result;
      //     if(resList){
      //         //获取三级分类
      //         let finalList = [];
      //         resList.map((item) =>{
      //             let child = getThreeCategory(item);
      //             if(child && child.length > 0){
      //               child.map((item) => finalList.push(item));
      //             }
      //         });
      //         finalList && finalList.map((item) =>{
      //             let obj ={};
      //             obj.id = item.id;
      //             obj.label = item.categoryName
      //             this.categoryOptions.push(obj);
      //         })
      //     }
      // },
      // 搜索商品
      async queryGoods(name = "") {
        const { result = [] } = await DistributionApi.queryGoods({ name });
        this.goodsList = result.map((item) => {
          const { code, name, id, picUrls, barCode } = item;
          // 格式化菜单
          return {
            goodsCode: code,
            barCode: barCode,
            goodsName: name,
            id,
            code,
            picUrls: picUrls[0],
          };
        });
      },

      // 获取门店列表
      async handleSearchStore(search, loading) {
        this.isGetStore = false;
        let data = {
          store_codes:search
        }
        let records = await DistributionApi.querystoreIds(data);

        records = records.data.map((v) => ({
          label: v.name,
          text: v.name,
          value: v.id,
          id: v.id,
        }));
        this.storeOptions = records;
        console.log("list===>", records.length, this.storeInfo.length);
        if (!records.length) {
          this.$forceUpdate();
          return;
        }
        this.isGetStore = true;
      },
      // 获取活动配置详情---编辑时
      getDetail() {
        return DistributionApi.getActivityConfig({
          configId: this.detailId,
          storeId: -1
        }).then(({ result }) => {
          this.changTypeFlag=true  //类型一旦选择无法修改

          console.log(result,"result")
          Object.assign(this.params, result);
          const {
            questions = [],
            goodsInfo = [],
            startTime = "",
            endTime = "",
            bannerIcon,
            storeInfo = [],
            storeType = "",
            ilustri,
          } = result;
          this.params.pushType = result.pushType
          this.params.bannerIconA = [bannerIcon];
          this.params.ilustri = ilustri.filter((item) => item);
          this.questions = questions.map((item) => {
            return { ...item, uuid: uuidv4() };
          });
          this.goodsInfo = goodsInfo.map((item) => {
            const { goodsCode, barCode, goodsName, picUrls, id } = item;
            return {
              ...item,
              uuid: uuidv4(),
              goodsItem: { goodsCode, barCode, goodsName, picUrls, id },
            };
          });
          console.log("selectStoreType", storeType);
          this.selectStoreType = storeType;
          this.storeInfo = storeInfo.map((item) => {
            return {
              label: item.storeName,
              text: item.storeName,
              value: item.storeId,
              id: item.storeId,
            };
          });
          // 获取门店列表的接口返回过慢，先用storeInfo作为选项，保证正常显示
          this.storeOptions = this.storeInfo;
        });
      },
      delItem(list, id) {
        // if (list.length === 1) {
        //   this.$vs.notify({
        //     color: "danger",
        //     title: "error",
        //     text: "最后一个不能再删除了",
        //     position: "top-right"
        //   });
        //   return;
        // }
        // 删除id元素
        const index = list.findIndex(({ uuid }) => uuid === id);
        list.splice(index, 1);
      },

      // 新增信息配置
      addQuestion(type, value) {
        console.log(type,value);
        this.questions.push({
          type,
          questionType: value,
          selectContent: [value === 4 ? 1 : ""],
          questionTitle: "",
          uuid: uuidv4(),
        });
        console.log(this.questions);
      },
      // 添加选项
      addOptions(item, index) {
        if (this.questions[index].selectContent.length > 6) {
          return this.$notifyError("最多添加6条选项");
        }
        this.questions[index].selectContent.push("");
      },

      // 删除选项
      delOptions(item, index) {
        this.questions[index].selectContent.splice(index, 1);
      },
      // 删除问题项
      delQuestion(item, index) {
        this.questions.splice(index, 1);
      },

      // 跟新活动头图
      updateUrlBanner(arr) {
        this.params.bannerIconA = arr;
      },

      // 跟新活动配图
      updateUrlIlu(arr) {
        this.params.ilustri = arr;
      },
      handleStoreInfo() {
        let storeInfos = [];
        // 判断是否为全部门店
        if (this.selectStoreType === 1) {
          this.params.storeInfo = this.storeOptions.map((item) => {
            return {
              storeId: item.id,
              storeName: item.name,
            };
          });
        } else {
          this.params.storeInfo = this.storeInfo.map((item) => {
            return {
              storeId: item.id,
              storeName: item.label,
            };
          });
        }
        // console.log("选择商品",this.params.storeInfo)
      },

      // 校验商品
      validateGoods() {
        return this.goodsInfo.some((item) => {
          return !item.goodsName || !item.goodsCount;
        });
      },
      // 表单校验
      handleValidate() {
        console.log(this.params.storeInfo, "===========")
        let error = false;
        if (this.params.pushType == 1 && !this.params.storeInfo.length) {
          error = true;
        }
        if (
          // !this.params.storeInfo.length ||
          !this.params.type ||
          !this.params.activityName ||
          !this.params.bannerIconA.length ||
          !this.params.desc || !this.params.pushType
        ) {
          console.log(this.params, "==========")
          error = true;
        }
        const isValidateGoods = this.validateGoods();
        if (this.params.type === 2 && !this.questions.length) {
          error = true;
        }
        if (
          this.params.type === 3 &&
          (!this.questions.length || isValidateGoods)
        ) {
          error = true;
        }
        console.log(error);
        return error;
      },
      // 保存配置
      save() {
        if (this.showTip) return;
        this.handleStoreInfo();
        if (this.handleValidate()) {
          return this.$notifyError("请完善活动配置");
        }

        this.disabled = true;
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: "#button-with-loading",
          scale: 0.45,
        });
        //当独立推送的时候 storeType传2
        let storeType = ''
        if (this.params.pushType == 2) {
          storeType = 2
        } else {
          storeType = this.selectStoreType === 1 ? 1 : 2
        }

        const params = {
          ...this.params,
          // storeType: this.selectStoreType === 1 ? 1 : 2,
          storeType: storeType,
          startTime: "2021-01-01 00:00:00",
          endTime: "2021-01-02 00:00:00",
          questions: this.questions,
          goodsInfo: this.goodsInfo.map((item) => {
            const { goodsItem = {} } = item;
            return { ...item, ...goodsItem };
          }),
          bannerIcon: this.params.bannerIconA[0],
          storeInfo: this.selectStoreType !== 1 ? this.params.storeInfo : [],
        };
        //编辑
        if (this.detailId) {
          DistributionApi.updateActivityConfig(params).then((res) => {
            console.log("123res", res);
            if (res.succ === 1) {
              this.success();
            } else if (this.params.pushType == 2 && res.code == 1) {
              this.$notifyError(res.error)
            } else {
              this.$notifyError("更新失败");
            }
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
            this.disabled = false;
          });
          return;
        }
        //新增
        DistributionApi.insertActivityConfig(params).then((res) => {
          if (res.succ === 1) {
            this.success();
          } else {
            this.$notifyError("添加失败");
          }
          this.disabled = false;
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        });
      },
      // 保存成功
      success() {
        this.$vs.notify({
          color: "success",
          title: "Success",
          text: "保存成功",
          position: "top-right",
        });
        this.back();
      },
      // 确认取消
      cancelAffirm() {
        this.$vs.dialog({
          type: "confirm",
          title: `请确认`,
          text: `是否确认取消`,
          acceptText: "确认",
          cancelText: "取消",
          accept: () => {
            this.back();
          },
        });
      },
      // 返回列表页
      back() {
        const name = "storeactivities";
        this.$router.push({ name, url: "/distribution/storeactivities" });
      },
    },
    watch: {
      selectStoreType(newValue, oldValue) {
        if (newValue === 2 && this.isEditAllStore) {
          this.storeInfo = [];
        }
        if(newValue === 1){
          this.handleSearchStore('')
        }
      },
      async importStoreIds(newValue, oldValue) {
        if (
          this.importStoreIds.indexOf(",") !== -1 ||
          this.importStoreIds.indexOf(" ") !== -1
        ) {
          return this.$notifyError("请填写正确格式");
        }
        const temp = this.importStoreIds.split("\n");
        const res = await DistributionApi.querystoreIds({ store_codes: temp });
        if (res.code!==200) {
          this.$notifyError("请填写正确的门店编号");
        } else {
          this.importStoreNum = res.data.length;
          this.inputStoreInfo = res.data.map((v) => {
            return {
              label: v.name,
              text: v.name,
              value: v.id,
              id: v.id,
            };
          });
        }
      },
    },
  };
</script>

<style lang="scss">
/deep/ .popup-imoprt-store {
  padding: 10px 20px;

  .vs-con-textarea {
    margin-bottom: 10px;

    /deep/ .vs-textarea {
      height: 100%;
    }
  }

  /deep/ .tips {
    font-size: 11px;
    color: #5e5873;
    margin-bottom: 5px;
  }

  .vs-button {
    margin-top: 20px;
    margin-right: 10px;
  }
}
</style>
<style scoped lang="scss">
@import "../../../form.scss";

.search-add-wrap {
  /deep/ .vs-button {
    padding: 0 10px !important;
  }
}

.input-tip {
  color: var(--vs-primary);
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e5873;
  width: 80px;
  line-height: 36px;
}

.table-inner-btn {
  padding: 0 15px;
}

.main-wrap {
  /deep/ .vs-card--content {
    padding: 0 24px;
    margin-top: 20px;

    .form {
      .form-item {
        width: 390px;
      }

      .vs-row {
        @include flex-mixin(row, flex-start, flex-start);

        .vs-textarea {
          height: 100% !important;
        }

        .vs-con-input {
          width: 390px;
        }

        .offset {
          margin-top: -50px;
        }

        .con-upload {
          .con-img-upload {
            padding: 0;
          }

          .con-input-upload {
            margin: 0;
            width: 100px;
            height: 100px;
          }
        }
      }

      .select-store-type {
        margin-left: 10px;
      }

      .disabled-select {
        display: inline-block;
        width: 390px;
        height: 38px;
        line-height: 38px;
        padding-left: 10px;
        box-sizing: border-box;
        background-color: #f5f5f5;
        color: #a9a9aa;
        cursor: not-allowed;
        border-radius: 4px;

        .vs-icon {
          margin-left: 290px;
          vertical-align: middle;
          margin-top: -2px;
          font-size: 22px;
        }
      }

      .mutiple-select {
        display: inline-block;

        /deep/ .vs__selected {
          background-color: #4090ff;
          border: 1px solid #4090ff;
          color: #fff;

          svg {
            stroke: #fff;
          }
        }

        .vs__dropdown-toggle {
          max-height: 257px;
          overflow: auto;
        }
      }

      /deep/ .vs-con-textarea {
        margin-bottom: 0;
      }
    }

    .title {
      height: 73px;
      line-height: 73px;
      margin: 20px 0 0;
    }

    .first {
      margin-top: 0;
    }

    .config-item {
      border-bottom: 1px solid #dcdfe6;
      padding: 20px 0;
      @include flex-mixin(row, stretch, flex-start);
      font-size: 14px;
      color: #5e5873;

      .type {
        width: 100px;
      }

      .label {
        line-height: 20px;
        margin-bottom: 8px;
      }

      .content {
        flex: 0.5;

        .option {
          margin-bottom: 10px;
          @include flex-mixin(row, stretch, flex-start);

          .btn {
            display: inline-block;
            margin: 0 10px;
            font-size: 25px;
            color: #5e5873;
            cursor: pointer;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .del {
        color: #4090ff;
        @include flex-mixin(row, flex-end, center);
        padding-bottom: 7px;
        display: none;

        .vs-icon {
          cursor: pointer;
          font-size: 18px;
          vertical-align: middle;
          padding-bottom: 2px;
        }

        span {
          cursor: pointer;
        }
      }

      &:hover {
        .del {
          display: flex;
        }
      }
    }

    .question-type {
      background: #f7f7fa;
      padding: 18px;
      width: 400px;
      margin-bottom: 20px;

      .btn {
        display: inline-block;
        padding: 3px 12px;
        background: #ffffff !important;
        border-radius: 4px;
        border: 1px solid #4090ff;
        margin-right: 8px;
        cursor: pointer;
      }
    }

    .import-store {
      // margin-left: 10px;
      padding: 10px !important;
    }

    // .vs__dropdown-menu {
    //   z-index: 99999999;
    // }
  }

  /deep/ .vs-input-number {
    width: 84px;
    margin: 0;
    padding: 0;

    .vs-input-number--button-plus,
    .vs-input-number--button-less {
      transform: translate(0px);
    }
  }
}

.btns {
  display: flex;
  justify-content: center;

  button {
    margin: 30px 15px;
  }
}

.questions {
  display: flex;
  flex-direction: column;

  .question {
    display: flex;
    margin-bottom: 6px;
  }
}

.wid300 {
  width: 300px;
}

.height100 {
  height: 100%;
}
</style>
